import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SaveRegionRequest } from '@shared/models/preference.model';
import {
  PreferenceElement,
  Template,
  UpdatePreference,
  UpdateTemplate
} from '@store/user/user.model';
import { TemplateCodeResponse, UpdatePreferenceResponse } from '@store/search-board/search-board.model';
import { UserPreferences } from '@store/settings/settings.model';
import { MixpanelService } from '@shared/services/mixpanel.service';
import { google } from '@shared/models/googlemaps.model';
import LatLngLiteral = google.maps.LatLngLiteral;

@Injectable({
  providedIn: 'root'
})
export class PreferenceService {

  private readonly baseUrl: string = '/api/preference';

  constructor(private readonly httpClient: HttpClient,
              private readonly mixpanelService: MixpanelService) {
  }

  public saveRegions(request: SaveRegionRequest): Observable<Array<LatLngLiteral>> {
    return this.httpClient.post<Array<LatLngLiteral>>(`${this.baseUrl}/save-regions`, request);
  }

  public saveMySearch(mySearch: Template): Observable<TemplateCodeResponse> {
    this.mixpanelService.track('Search - Create New Saved Search');
    return this.httpClient.post<TemplateCodeResponse>('/api/save-search-template', mySearch);
  }

  public deleteCustomMySearch(templateId: string): Observable<void> {
    return this.httpClient.delete<void>('/api/delete-search-template', {params: {templateId}});
  }

  public updateCustomMySearch(mySearch: Template): Observable<TemplateCodeResponse> {
    return this.httpClient.post<TemplateCodeResponse>('/api/update-search-template', mySearch);
  }

  public saveEmailSignature(signature: string): Observable<void> {
    return this.httpClient.post<void>('api/preference/save-email-sig', {signatureInput: signature});
  }

  public saveComparablesSearchCriteria(preferenceElements: Array<PreferenceElement>): Observable<UpdatePreferenceResponse> {
    return this.httpClient.post<UpdatePreferenceResponse>(`${this.baseUrl}/save-comp-search-criteria`, preferenceElements);
  }

  public saveNeighborsSearchCriteria(preferenceElements: Array<PreferenceElement>): Observable<UpdatePreferenceResponse> {
    return this.httpClient.post<UpdatePreferenceResponse>(`${this.baseUrl}/save-neighbors-search-criteria`, preferenceElements);
  }

  public savePreferenceGroupSettings(requestList: Array<UpdatePreference>): Observable<void> {
    return this.httpClient.post<void>(`${this.baseUrl}/save-preferences`, requestList);
  }

  public updateTemplate(requestData: UpdateTemplate): Observable<void> {
    return this.httpClient.post<void>(`${this.baseUrl}/update-template`, requestData);
  }

  public restoreDefaultPreference(): Observable<Array<UserPreferences>> {
    return this.httpClient.get<Array<UserPreferences>>(`${this.baseUrl}/restore-default-preferences`);
  }

  public getUserPreferences(): Observable<Array<UserPreferences>> {
    return this.httpClient.get<Array<UserPreferences>>(`${this.baseUrl}/get-user-preferences`);
  }
}
